// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orders-view__timeline-btn{border-top-right-radius:0;border-bottom-right-radius:0;right:0!important;top:7.5rem!important;z-index:3!important}.orders-view>div.v-card:not(:last-child){margin-bottom:1rem}.orders-view .v-card__actions>.v-btn:not(:last-child){margin-right:.5rem}@media only screen and (max-width:117.5rem){.orders-view__timeline-btn{top:7.5rem!important}}", ""]);
// Exports
module.exports = exports;
